import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kuva kõik valikud

  <span style="color:#85c1dc;">**FI:**</span>
  Näytä kaikki vaihtoehdot

  <span style="color:#85c1dc;">**RU:**</span>
  Показать все варианты
*/
/* @__NO_SIDE_EFFECTS__ */
const m1888 = msg(
  mf`Kuva kõik valikud`,
  mf`Näytä kaikki vaihtoehdot`,
  mf`Показать все варианты`,
)

export { m1888 as 'w.module.filter_bar.show_all' }